import type { ComponentProps } from 'react';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';
import { HeaderLayout, HeaderLayoutButton, HeaderLayoutSearchButton } from '@change-corgi-ds-v2/layout';

import { Dropdown } from './components/Dropdown';
import { Logo } from './components/Logo';
import { useHeader } from './hooks/useHeader';

export const Header: React.FC<ComponentProps<'div'>> = (props) => {
	const {
		data: { navLinks, userIdentified, showMenu },
	} = useHeader();
	const { translate } = useI18n();

	return (
		<HeaderLayout
			logo={<Logo />}
			navLinks={navLinks}
			searchButton={
				showMenu && (
					<HeaderLayoutSearchButton
						href="/search"
						aria-label={translate('fe.components.header.search')}
						data-qa="header-search-button"
					>
						<Translate value="fe.components.header.search" />
					</HeaderLayoutSearchButton>
				)
			}
			userActionSlot={
				showMenu &&
				(userIdentified ? (
					<Dropdown />
				) : (
					<HeaderLayoutButton href="/login_or_join?user_flow=nav">
						<Translate value="fe.components.header.log_in" />
					</HeaderLayoutButton>
				))
			}
			mobileMenu={showMenu && <Dropdown mobile />}
			{...props}
		/>
	);
};
